import { NextRouter } from 'next/router';

import { IAvailabilitySearchQueryInstance } from '@/availability/models';
import {
  getAmendBookingAvailabilityUrlFromQueryInstance,
  getManageBookingUrl,
} from '@/booking-management/urls';
import { BookingRequest } from '@/booking/interfaces';

import { AmendBookingCheckoutNavigator } from '../interfaces';

const noop = () => {
  //
};

export const createAmendBookingAvailabilityNavigator = ({
  query,
  oldBooking,
  router,
  operaId,
}: {
  query: IAvailabilitySearchQueryInstance | undefined;
  oldBooking: BookingRequest;
  router: NextRouter;
  operaId?: string;
}): AmendBookingCheckoutNavigator => {
  return {
    additionalInformationPage: noop,
    expiredPage: noop,
    compareChangesPage: noop,
    paymentPage: noop,
    pendingPage: noop,
    confirmationPage: noop,
    manageBookingPage: () => router.push(getManageBookingUrl(operaId)),
    searchResultsPage: () =>
      router.push(
        getAmendBookingAvailabilityUrlFromQueryInstance({
          query,
          oldBooking,
        })
      ),
  };
};
